export default {
  DASHBOARD: '/',
  LOGIN: '/login',
  REGISTER: '/registro',
  VERIFY_EMAIL: '/verificar/:code',
  RESET: '/reset',
  RESET_PASSWORD: '/reset/password',
  CONTPAQI: '/contpaqi',
};
